<template>
  <div class="footer green_bg">
    <div class="submit">
      <p class="title">
        {{ $t('common.p22') }}
      </p>
      <van-row>
        <van-col span="18">
          <van-field
            v-model.trim="input"
            class="email-input"
            aria-label="email"
            @click="toBottom"
          />
        </van-col>
        <van-col span="6">
          <van-button
            type="default"
            @click="sumit"
          >
            {{ $t('common.p23') }}
          </van-button>
        </van-col>
      </van-row>
    </div>

    <div class="line green" />

    <div class="follow">
      <p class="title">
        {{ $t('common.p84') }}
      </p>
      <div>
        <a
          target="_blank"
          href="https://www.facebook.com/pppoker123"
          aria-label
        >
          <img
            class="facebook-img"
            src="/official_mobile/static/img/home/facebook.png"
            alt="facebook"
          >
        </a>
        <a
          target="_blank"
          href="https://www.instagram.com/pppokerglobal"
          aria-label
        >
          <img
            class="ins-img"
            src="/official_mobile/static/img/home/ins.png"
            alt="ins"
          >
        </a>
        <a
          target="_blank"
          href="https://www.youtube.com/channel/UCpklAxJQBUEoFISwCn9o4jg?view_as=subscriber"
          aria-label
        >
          <img
            class="youtu-img"
            src="/official_mobile/static/img/home/youtube.png"
            alt="youtube"
          >
        </a>
        <!-- <a
          target="_blank"
          href="https://twitter.com/pppokerofficial"
          aria-label
        >
          <img
            class="twitter-img"
            src="/official_mobile/static/img/home/twitter.png"
            alt="twitter"
          >
        </a> -->
      </div>
    </div>

    <div class="line green" />

    <div class="jump_btn">
      <a
        id="footfbAndroidDL"
        :href="FB_VERSON"
        aria-label="download android"
        @click="toBury('officialwebsite_m_bottom_download_android', 1009, 1, 0, 0, 5)"
      >
        <img
          src="/official_mobile/static/img/home/download_08.png"
          alt
        >
      </a>
      <a
        href="https://apps.apple.com/in/app/pppoker-nlh-plo-ofc/id1101622978"
        aria-label="download apple"
        @click="toBury('officialwebsite_m_bottom_homepage_download_appstore', 1009, 1, 0, 0, 6)"
      >
        <img
          src="/official_mobile/static/img/home/download_06.png"
          alt
        >
      </a>
      <a
        href="https://play.google.com/store/apps/details?id=com.lein.pppoker.android"
        aria-label="download android"
        @click="toBury('officialwebsite_m_bottom_homepage_download_googleplay', 1009, 1, 0, 0, 7)"
      >
        <img
          src="/official_mobile/static/img/home/download_05.png"
          alt
        >
      </a>
      <!-- <a
        href="https://pppoker.net/m/guide_old.html"
        aria-label="download guide"
        @click="toBury('officialwebsite_m_bottom_homepage_download_guide', 1009, 1, 0, 0, 8)"
      >
        <img
          src="/official_mobile/static/img/home/download_07.png"
          alt
        >
      </a> -->
    </div>

    <div class="line green" />

    <div class="content">
      <router-link to="/about">
        {{ $t('common.p24') }}
      </router-link>
      <router-link to="/brand">
        {{ $t('common.p25') }}
      </router-link>
      <router-link to="/legal-affairs/Privacy">
        {{ $t('common.p26') }}
      </router-link>
      <router-link to="/legal-affairs/Terms">
        {{ $t('common.p27') }}
      </router-link>
      <router-link to="/legal-affairs/Unsolicited">
        {{ $t('common.p29') }}
      </router-link>
      <router-link to="/legal-affairs/Community">
        {{ $t('common.p28') }}
      </router-link>
      <router-link to="/legal-affairs/Public">
        {{ $t('common.p112') }}
      </router-link>
    </div>

    <div class="copyright">
      <i18n path="common.p30">
        <span
          place="year"
          style="color:#00471d;"
        >
          {{ new Date().getFullYear() }}
        </span>
      </i18n>
    </div>

    <van-dialog
      v-model="show"
      class="subscribe_dialog"
      :show-confirm-button="false"
    >
      <div
        v-if="subscribe_step === 1"
        class="sub_step1 regular_color"
      >
        <img
          class="subscribe_01"
          src="/official_mobile/static/img/home/subscribe_01.jpg"
        >
        <div class="sub_content">
          <p class="c_title primary_color">
            {{ $t('common.p98') }}
          </p>
          <p>{{ $t('common.p99') }}</p>
          <p class="error">
            {{ subscribe_error }}
          </p>
          <van-row>
            <van-field
              v-model.trim="input"
              class="email-input"
              aria-label="email"
            />
          </van-row>
          <div
            class="sub_button"
            @click="subscribe_sumit"
          >
            <p>{{ $t('common.p101') }}</p>
          </div>
          <van-checkbox
            v-model="checked"
            checked-color="#289753"
            shape="square"
          >
            {{ $t('common.p102') }}
          </van-checkbox>
        </div>
        <img
          class="subscribe_close"
          src="/official_mobile/static/img/home/subscribe_close.png"
          @click="closeDialog"
        >
      </div>
      <div
        v-if="subscribe_step === 2"
        class="sub_step2 regular_color"
      >
        <img
          class="subscribe_02"
          src="/official_mobile/static/img/home/subscribe_02.jpg"
        >
        <div class="sub_content">
          <p>{{ $t('common.p32') }}</p>
          <p class="p2">
            {{ $t('common.p33') }}
          </p>
          <div
            class="sub_button"
            @click="closeDialog"
          >
            <p>{{ $t('common.p39') }}</p>
          </div>
        </div>

        <img
          class="subscribe_close"
          src="/official_mobile/static/img/home/subscribe_close.png"
          @click="closeDialog"
        >
      </div>
    </van-dialog>

    <transition name="van-slide-up">
      <div
        v-if="show_cookies"
        class="cookies_fixed"
      >
        <i18n
          path="common.p109"
          tag="p"
          class="p1"
        >
          <template slot="link">
            <router-link
              to="/legal-affairs/Cookies"
            >
              {{ $t('common.p111') }}
            </router-link>
          </template>
        </i18n>
        <div
          class="cookies_button"
          @click="closeCookesPop"
        >
          <p>{{ $t('common.p110') }}</p>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
// @ is an alias to /src
import { receiveUserEmail } from '@/api/official'
import Cookies from 'js-cookie'
import moment from 'moment'

export default {
  data () {
    return {
      input: '',
      show: false,
      FB_VERSON: '',
      checked: false,
      subscribe_error: '',
      subscribe_step: 0,
      show_cookies: false
    }
  },
  created () {
    // eslint-disable-next-line no-undef
    this.FB_VERSON = FB_VERSON
  },
  mounted () {
    setTimeout(() => {
      let subscribe = Cookies.get('subscribe')
      if (!subscribe || (moment().format('YYYY-MM-DD') > subscribe)) {
        this.show = true
        this.subscribe_step = 1
      }
    }, 30000)

    let cookiesPop =  Cookies.get('cookiesPop')
    if(!cookiesPop) {
      this.show_cookies = true
    }
  },
  methods: {
    closeCookesPop () {
      this.show_cookies = false
      Cookies.set('cookiesPop', true)
    },
    closeDialog () {
      this.show = false
      this.input = ''
      if (this.checked) {
        Cookies.set('subscribe', moment().format('YYYY-MM-DD'), { expires: 1000 })
      }
    },
    toBottom () {
      if (
        navigator.userAgent.indexOf('Android') > -1 ||
        navigator.userAgent.indexOf('Adr') > -1
      ) {
        document.querySelector('.footer').scrollIntoView(true)
      }
    },
    subscribe_sumit () {
      var email = this.input
      // eslint-disable-next-line no-useless-escape
      var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!reg.test(email)) {
        this.subscribe_error = this.$t('common.p104')
      } else {
        var t = Date.parse(new Date())
        // eslint-disable-next-line no-undef
        var sign = hex_md5(email + '|' + t)

        receiveUserEmail({
          email,
          time: t,
          sign
        })
          .then(() => {
            this.subscribe_step = 2
            Cookies.set('subscribe', '2100-01-01', { expires: 1000 })
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    sumit () {
      var email = this.input
      // eslint-disable-next-line no-useless-escape
      var reg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/
      if (!reg.test(email)) {
        alert(this.$t('common.p104').replace('*', ''))
      } else {
        var t = Date.parse(new Date())
        // eslint-disable-next-line no-undef
        var sign = hex_md5(email + '|' + t)

        receiveUserEmail({
          email,
          time: t,
          sign
        })
          .then(() => {
            Cookies.set('subscribe', '2100-01-01', { expires: 1000 })
            this.subscribe_step = 2
            this.show = true
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    toBury (key, f1, f2, f3, f4, f5) {
      this.$gtag.event(key, {
        'event_category': 'download',
        'event_label': 'button',
        'value': 1
      })
      this.$axios.get(
        'https://client-click-v2.cn-hongkong.log.aliyuncs.com/logstores/client-logstroe/track',
        {
          params: {
            APIVersion: '0.6.0',
            __topic__: key,
            f1,
            f2,
            f3,
            f4,
            f5,
            log_type: 10001
          }
        }
      )
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.special-effect-enter-active,
.special-effect-leave-active {
  transition: all 1s;
}
.special-effect-enter,
.special-effect-leave-to {
  top: 50px;
  opacity: 0;
}

.footer {
  position: relative;
  font-size: 24px;
  color: #fff;

  padding: 50px 40px 160px 40px;
  .submit {
    padding-top: 30px;
    padding-bottom: 70px;
    .title {
      margin-bottom: 20px;
    }
    .email-input {
      line-height: 20px;
      height: 53px;
      font-size: 24px;
      background-color: #1f6830;
      padding: 10px 16px;
    }
    /deep/.van-field__control {
      color: #fff;
    }
    /deep/.van-button {
      height: 53px;
      width: 100%;
      font-size: 24px;
      border: none;
      color: #279754;
      line-height: 52px;
    }
  }
  .line {
    width: 100%;
    margin: 0px;
    border-top: 2px solid #156a32;
  }
  .follow {
    padding: 34px 0px;
    .title {
      margin-bottom: 20px;
    }
    img {
      display: inline-block;
    }
    a {
      display: inline-block;
      margin-right: 48px;
      vertical-align: middle;
    }
    .facebook-img {
      width: 28px;
    }
    .ins-img {
      width: 46px;
    }
    .youtu-img {
      width: 58px;
    }
    .twitter-img {
      width: 50px;
    }
  }
  .jump_btn {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 60px 0px;
    margin-bottom: -25px;
    a {
      display: inline-block;
      margin: 0px 10px 25px 10px ;
    }
    img {
      display: inline-block;
      width: 245px;
    }
  }

  .content {
    padding: 20px 0px;
    display: inline-block;
    margin-right: 100px;
    a {
      color: #ffffff;
      font-size: 30px;
      margin: 20px 0px;
      display: block;
    }
  }
  .copyright {
    color: #00471d;
    font-size: 24px;
  }

  .subscribe_dialog {
    border-radius: 0px;
    width: 80%!important;
  }

  .sub_step1 {
    width: 100%;
    height: auto;
    background-color: #eee;
    position: relative;
    .subscribe_01 {
      width: 100%;
      display: block;
    }
    .subscribe_close {
      position: absolute;
      width: 50px;
      height: 50px;
      top: 0px;
      right: 0px;
      padding: 28px 28px;
      display: block;
      cursor: pointer;
    }
    .sub_content {
      padding: 0px 30px 40px 30px;
      p {
        font-size: 28px;
        line-height: 32px;
      }
      .c_title {
        font-size: 32px;
        margin-bottom: 28px;
      }
      .error {
        font-size: 26px;
        line-height: 28px;
        color: #942321;
        min-height: 32px;
        margin-top: 10px;
      }
      .van-row {
        border: 1PX solid #DCDFE6;
        margin-bottom: 26px;
        margin-top: 20px;
        .email-input {
          padding: 10px 10px;
        }
      }
      .sub_button {
        width: 100%;
        height: 66px;
        background-color: #4a965b;
        margin: 26px 0px;
        cursor: pointer;
        p {
          font-size: 36px;
          line-height: 66px;
          text-align: center;
          color: #fff;
        }
      }
      .van-checkbox {
        font-size: 24px;
        /deep/.van-checkbox__icon {
          font-size: 28px;
          .van-icon {
            border-color:#b7b7b7;
          }
        }
      }
    }
  }
  .sub_step2 {
    width: 100%;
    height: auto;
    background-color: #eee;
    position: relative;
    .subscribe_02 {
      width: 100%;
      display: block;
    }
    .subscribe_close {
      position: absolute;
      width: 50px;
      height: 50px;
      top: 0px;
      right: 0px;
      padding: 28px 28px;
      display: block;
      cursor: pointer;
    }
    .sub_content {
      padding: 40px 30px 50px 30px;
      p {
        font-size: 28px;
        line-height: 36px;
      }
      .p2 {
        margin-bottom: 28px;
      }
      .cont-bottom {
        font-size: 26px;
        line-height: 36px;
        text-align: right;
      }
      .sub_button {
        width: 100%;
        height: 66px;
        background-color: #4a965b;
        margin-top: 40px;
        cursor: pointer;
        p {
          font-size: 36px;
          line-height: 66px;
          text-align: center;
          color: #fff;
        }
      }
    }
  }

  .cookies_fixed {
    position: fixed;
    z-index: 100;
    left: 0px;
    bottom: 0px;
    width: 100%;
    padding: 30px 0px;
    // background-color: #f2f2f2;
    background-color: rgba(0, 0, 0, 0.8);
    .p1 {
      font-size: 26px;
      // color: #595959;
      color: #ffffff;
      line-height: 30px;
      padding: 4px 30px;
      margin-bottom: 30px;
      a {
        color: #ffffff;
        line-height: 30px;
        box-shadow: 0 1PX;
      }
    }
    .cookies_button {
      width: 528px;
      height: 65px;
      background-color: #009a4c;
      border-radius: 4px;
      border: solid 1px #009a4c;
      margin: 0px auto;
      text-align: center;
      cursor: pointer;
      p {
        font-size: 30px;
        color: #ffffff;
        line-height: 65px;
      }
    }
  }
}
</style>
